/* Lotus Edition light and dark mode button */
(function () {
  var root = document.documentElement;
  var btn = document.querySelector('.lx-mode-btn');
  if (!btn) return;
  function label() {
    var dark = root.getAttribute('data-lx-theme') === 'dark';
    btn.setAttribute('aria-pressed', dark ? 'true' : 'false');
    btn.setAttribute('aria-label', dark ? 'Switch to light mode' : 'Switch to dark mode');
  }
  function set(mode, save) {
    root.setAttribute('data-lx-theme', mode);
    if (save) {
      root.removeAttribute('data-lx-palette');
      try { localStorage.setItem('lx_mode', mode); localStorage.removeItem('lx_palette'); } catch (e) {}
    }
    label();
    document.dispatchEvent(new CustomEvent('lx:mode', { detail: mode }));
  }
  /* The moon swaps between the light and dark version of the current look */
  var PAIR = { classic: 'dark', dark: 'classic', 'mono-white': 'mono-black', 'mono-black': 'mono-white', pink: 'maroon', maroon: 'pink', black: 'mono-white', emerald: 'mono-white' };
  function cur() {
    var p = root.getAttribute('data-lx-palette');
    return p || (root.getAttribute('data-lx-theme') === 'dark' ? 'dark' : 'classic');
  }
  function swap(p) {
    var mode = (p === 'classic' || p === 'pink' || p === 'mono-white') ? 'light' : 'dark';
    if (p === 'classic' || p === 'dark') {
      root.removeAttribute('data-lx-palette');
      try { localStorage.removeItem('lx_palette'); } catch (e) {}
    } else {
      root.setAttribute('data-lx-palette', p);
      try { localStorage.setItem('lx_palette', p); } catch (e) {}
    }
    root.setAttribute('data-lx-theme', mode);
    try { localStorage.setItem('lx_mode', mode); } catch (e) {}
    label();
    document.dispatchEvent(new CustomEvent('lx:mode', { detail: mode }));
  }
  btn.addEventListener('click', function () { swap(PAIR[cur()] || 'dark'); });
  if (window.matchMedia) {
    var mq = window.matchMedia('(prefers-color-scheme: dark)');
    var follow = function (e) {
      var saved = null;
      if (root.hasAttribute('data-lx-palette')) return;
      try { saved = localStorage.getItem('lx_mode'); } catch (err) {}
      if (saved !== 'dark' && saved !== 'light') set(e.matches ? 'dark' : 'light', false);
    };
    if (mq.addEventListener) mq.addEventListener('change', follow); else if (mq.addListener) mq.addListener(follow);
  }
  label();
  document.addEventListener('lx:palette', label);
})();

/* Colour picker: shoppers choose the website colours */
(function () {
  var root = document.documentElement;
  var btn = document.querySelector('.lx-pal-btn'), panel = document.getElementById('lx-pal-panel');
  if (!btn || !panel) return;
  var opts = Array.prototype.slice.call(panel.querySelectorAll('[data-pal]'));
  function current() {
    var p = root.getAttribute('data-lx-palette');
    if (p) return p;
    return root.getAttribute('data-lx-theme') === 'dark' ? 'dark' : 'classic';
  }
  function mark() {
    var c = current();
    opts.forEach(function (o) { var on = o.getAttribute('data-pal') === c; o.setAttribute('aria-checked', on ? 'true' : 'false'); o.classList.toggle('is-on', on); o.tabIndex = on ? 0 : -1; });
  }
  function choose(p) {
    var mode = (p === 'classic' || p === 'pink' || p === 'mono-white') ? 'light' : 'dark';
    if (p === 'classic' || p === 'dark') {
      root.removeAttribute('data-lx-palette');
      try { localStorage.removeItem('lx_palette'); } catch (e) {}
    } else {
      root.setAttribute('data-lx-palette', p);
      try { localStorage.setItem('lx_palette', p); } catch (e) {}
    }
    root.setAttribute('data-lx-theme', mode);
    try { localStorage.setItem('lx_mode', mode); } catch (e) {}
    mark();
    document.dispatchEvent(new CustomEvent('lx:palette', { detail: p }));
    document.dispatchEvent(new CustomEvent('lx:mode', { detail: mode }));
  }
  function open(o) {
    if (o) { panel.removeAttribute('hidden'); mark(); var on = panel.querySelector('.is-on'); if (on) on.focus(); }
    else panel.setAttribute('hidden', '');
    btn.setAttribute('aria-expanded', o ? 'true' : 'false');
  }
  btn.addEventListener('click', function (e) { e.stopPropagation(); open(panel.hasAttribute('hidden')); });
  opts.forEach(function (o, i) {
    o.addEventListener('click', function () { choose(o.getAttribute('data-pal')); open(false); btn.focus(); });
    o.addEventListener('keydown', function (e) {
      var k = e.key, n = null;
      if (k === 'ArrowDown' || k === 'ArrowRight') n = opts[(i + 1) % opts.length];
      if (k === 'ArrowUp' || k === 'ArrowLeft') n = opts[(i - 1 + opts.length) % opts.length];
      if (n) { e.preventDefault(); n.focus(); }
    });
  });
  document.addEventListener('click', function (e) { if (!panel.hasAttribute('hidden') && !panel.contains(e.target)) open(false); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hasAttribute('hidden')) { open(false); btn.focus(); } });
  document.addEventListener('lx:mode', mark);
  mark();
})();

/* Snow, rain and temperature that match the shopper's weather */
(function () {
  var cfg = window.lxFx || {};
  var mode = cfg.mode || 'auto';
  var showTemp = cfg.temp !== false;
  var forced = false;
  try {
    var q = new URLSearchParams(location.search).get('lx_weather');
    if (q === 'snow' || q === 'rain' || q === 'off' || q === 'auto') { mode = q; forced = q !== 'auto'; }
  } catch (e) {}
  var motionOk = forced || !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var canDraw = !!(window.requestAnimationFrame && document.createElement('canvas').getContext);
  var wantFx = mode !== 'off' && motionOk && canDraw;
  if (!wantFx && !showTemp) return;

  var CACHE = 'lx_wx2', TTL = 30 * 60 * 1000, started = false;

  function kindFor(code) {
    code = +code;
    if ([71, 73, 75, 77, 85, 86].indexOf(code) > -1) return 'snow';
    if ((code >= 51 && code <= 67) || (code >= 80 && code <= 82) || code >= 95) return 'rain';
    return 'none';
  }
  function readCache() {
    try {
      var c = JSON.parse(localStorage.getItem(CACHE) || 'null');
      if (c && c.t && Date.now() - c.t < TTL) return c;
    } catch (e) {}
    return null;
  }
  function saveCache(w) { try { w.t = Date.now(); localStorage.setItem(CACHE, JSON.stringify(w)); } catch (e) {} }
  function getJSON(url, ms) {
    var ctrl = window.AbortController ? new AbortController() : null;
    var timer = setTimeout(function () { if (ctrl) ctrl.abort(); }, ms || 5000);
    return fetch(url, ctrl ? { signal: ctrl.signal } : {}).then(function (r) {
      clearTimeout(timer);
      if (!r.ok) throw new Error('http ' + r.status);
      return r.json();
    });
  }
  function lookup() {
    return getJSON('https://ipapi.co/json/', 4000).then(function (d) {
      var lat = +d.latitude, lon = +d.longitude;
      if (!isFinite(lat) || !isFinite(lon) || (!lat && !lon)) throw new Error('no location');
      var f = ['US', 'LR', 'MM', 'BS', 'KY', 'PW', 'FM', 'MH', 'PR', 'GU', 'VI', 'AS'].indexOf(d.country_code) > -1;
      return getJSON('https://api.open-meteo.com/v1/forecast?latitude=' + lat.toFixed(2) + '&longitude=' + lon.toFixed(2) +
        '&current=weather_code,temperature_2m,is_day' + (f ? '&temperature_unit=fahrenheit' : ''), 5000).then(function (m) {
        var c = m && m.current;
        if (!c || !isFinite(+c.temperature_2m)) throw new Error('no weather');
        return { code: +c.weather_code, temp: Math.round(+c.temperature_2m), unit: f ? 'F' : 'C', day: c.is_day !== 0, city: d.city || '' };
      });
    });
  }

  var ICONS = {
    sun: '<circle cx="12" cy="12" r="4"/><path d="M12 2.5v2M12 19.5v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2.5 12h2M19.5 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4"/>',
    moon: '<path d="M20 14.5A8 8 0 0 1 9.5 4a8 8 0 1 0 10.5 10.5z"/>',
    cloud: '<path d="M7 18h10.5a4 4 0 0 0 .4-8A6 6 0 0 0 6.3 11.2 3.5 3.5 0 0 0 7 18z"/>',
    rain: '<path d="M7 15h10.5a3.7 3.7 0 0 0 .4-7.4A5.6 5.6 0 0 0 6.3 8.7 3.2 3.2 0 0 0 7 15z"/><path d="M9 18l-1 2.5M13 18l-1 2.5M17 18l-1 2.5"/>',
    snow: '<path d="M7 14h10.5a3.7 3.7 0 0 0 .4-7.4A5.6 5.6 0 0 0 6.3 7.7 3.2 3.2 0 0 0 7 14z"/><path d="M9 18.5h.01M12.5 20h.01M16 18.5h.01"/>',
    storm: '<path d="M7 14h10.5a3.7 3.7 0 0 0 .4-7.4A5.6 5.6 0 0 0 6.3 7.7 3.2 3.2 0 0 0 7 14z"/><path d="M12.5 15l-2 3.5h3l-2 3.5"/>',
    fog: '<path d="M4 9h16M6 13h12M4 17h16"/>'
  };
  function iconFor(w) {
    var c = w.code;
    if (c >= 95) return 'storm';
    var k = kindFor(c);
    if (k !== 'none') return k;
    if (c === 45 || c === 48) return 'fog';
    if (c >= 2) return 'cloud';
    return w.day ? 'sun' : 'moon';
  }
  function showChip(w) {
    if (!showTemp || !w || !isFinite(w.temp)) return;
    var bar = document.querySelector('.lx-bar');
    if (!bar || bar.querySelector('.lx-wx')) return;
    var el = document.createElement('span');
    el.className = 'lx-wx';
    el.setAttribute('role', 'img');
    var place = w.city ? w.city : 'your area';
    el.setAttribute('aria-label', 'Weather in ' + place + ': ' + w.temp + ' degrees ' + (w.unit === 'F' ? 'Fahrenheit' : 'Celsius'));
    el.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true">' + ICONS[iconFor(w)] + '</svg>' +
      '<span class="lx-wx__temp" aria-hidden="true">' + w.temp + '&deg;' + w.unit + '</span>' +
      (w.city ? '<span class="lx-wx__city" aria-hidden="true"></span>' : '');
    if (w.city) el.querySelector('.lx-wx__city').textContent = w.city;
    bar.classList.add('has-wx');
    bar.appendChild(el);
  }
  var cached = readCache();
  if (cached) {
    if (forced) start(mode);
    showChip(cached.ok ? cached : null);
    if (!forced && cached.ok && wantFx) { var k0 = kindFor(cached.code); if (k0 !== 'none') start(k0); }
  } else {
    if (forced && wantFx) start(mode);
    lookup().then(function (w) {
      w.ok = true; saveCache(w);
      showChip(w);
      if (!forced && wantFx) { var k1 = kindFor(w.code); if (k1 !== 'none') start(k1); }
    }).catch(function () { saveCache({ ok: false }); });
  }

  function start(kind) {
    if (started) return; started = true;
    var cv = document.createElement('canvas');
    cv.className = 'lx-fx lx-fx--' + kind;
    cv.setAttribute('aria-hidden', 'true');
    document.body.appendChild(cv);
    var ctx = cv.getContext('2d');
    var W = 0, H = 0, dpr = 1, parts = [], raf = 0, running = false;

    function dark() { return document.documentElement.getAttribute('data-lx-theme') === 'dark'; }
    /* Six-armed crystal flakes, drawn once and reused */
    var SPR = 64, sprites = { light: [], dark: [] };
    function crystal(style, darkMode) {
      var c = document.createElement('canvas'), q = SPR * 2;
      c.width = c.height = q;
      var g = c.getContext('2d'), R = q * 0.44;
      g.translate(q / 2, q / 2); g.lineCap = 'round'; g.lineJoin = 'round';
      function arms() {
        g.beginPath();
        for (var i = 0; i < 6; i++) {
          var a = i * Math.PI / 3, ca = Math.cos(a), sa = Math.sin(a);
          g.moveTo(0, 0); g.lineTo(ca * R, sa * R);
          var br = style === 0 ? [[0.42, 0.3], [0.68, 0.22]] : style === 1 ? [[0.5, 0.34]] : [[0.32, 0.2], [0.55, 0.26], [0.78, 0.16]];
          for (var b = 0; b < br.length; b++) {
            var px = ca * R * br[b][0], py = sa * R * br[b][0], L = R * br[b][1];
            g.moveTo(px, py); g.lineTo(px + Math.cos(a + 0.9) * L, py + Math.sin(a + 0.9) * L);
            g.moveTo(px, py); g.lineTo(px + Math.cos(a - 0.9) * L, py + Math.sin(a - 0.9) * L);
          }
          if (style === 1) { g.moveTo(ca * R * 0.86, sa * R * 0.86); g.arc(ca * R * 0.86, sa * R * 0.86, R * 0.06, 0, 6.283); }
        }
      }
      var w = Math.max(4, q * 0.075);
      if (!darkMode) { arms(); g.strokeStyle = 'rgba(70,98,138,.75)'; g.lineWidth = w + 6; g.stroke(); }
      arms(); g.strokeStyle = darkMode ? '#ffffff' : '#F2F7FD'; g.lineWidth = w; g.stroke();
      g.beginPath();
      for (var k = 0; k < 6; k++) { var t = k * Math.PI / 3 + Math.PI / 6; g.lineTo(Math.cos(t) * R * 0.14, Math.sin(t) * R * 0.14); }
      g.closePath(); g.fillStyle = darkMode ? '#ffffff' : '#F2F7FD'; g.fill();
      if (!darkMode) { g.strokeStyle = 'rgba(70,98,138,.75)'; g.lineWidth = 3; g.stroke(); }
      return c;
    }
    if (kind === 'snow') {
      for (var st = 0; st < 3; st++) { sprites.light.push(crystal(st, false)); sprites.dark.push(crystal(st, true)); }
    }
    function make(initial) {
      if (kind === 'snow') {
        var big = Math.random() < 0.35;
        return { x: Math.random() * W, y: initial ? Math.random() * H : -30,
          z: big ? 28 + Math.random() * 14 : 15 + Math.random() * 10,
          v: 0.45 + Math.random() * 0.8, a: Math.random() * 6.283, s: 0.004 + Math.random() * 0.01,
          rot: Math.random() * 6.283, rs: (Math.random() - 0.5) * 0.02, t: Math.floor(Math.random() * 3), o: 0.7 + Math.random() * 0.3 };
      }
      return { x: Math.random() * (W + 80) - 40, y: initial ? Math.random() * H : -20 - Math.random() * 60,
        l: 9 + Math.random() * 10, v: 7 + Math.random() * 5, o: 0.35 + Math.random() * 0.4 };
    }
    function size() {
      dpr = Math.min(window.devicePixelRatio || 1, 2);
      W = window.innerWidth; H = window.innerHeight;
      cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      var n = kind === 'snow' ? Math.min(40, Math.max(14, Math.round(W / 30))) : Math.min(110, Math.round(W / 9));
      while (parts.length < n) parts.push(make(true));
      parts.length = n;
    }
    function frame() {
      ctx.clearRect(0, 0, W, H);
      var dk = dark();
      if (kind === 'snow') {
        var set = dk ? sprites.dark : sprites.light;
        for (var i = 0; i < parts.length; i++) {
          var p = parts[i];
          p.a += p.s; p.y += p.v * (p.z / 26); p.x += Math.sin(p.a) * 0.5; p.rot += p.rs;
          if (p.y > H + 30 || p.x < -30 || p.x > W + 30) { parts[i] = make(false); continue; }
          ctx.save(); ctx.globalAlpha = p.o; ctx.translate(p.x, p.y); ctx.rotate(p.rot);
          ctx.drawImage(set[p.t], -p.z / 2, -p.z / 2, p.z, p.z);
          ctx.restore();
        }
      } else {
        ctx.lineWidth = 1.2; ctx.lineCap = 'round';
        for (var j = 0; j < parts.length; j++) {
          var d = parts[j];
          d.y += d.v; d.x -= d.v * 0.12;
          if (d.y > H + 20) { parts[j] = make(false); continue; }
          ctx.strokeStyle = dk ? 'rgba(200,215,235,' + (d.o * 0.7).toFixed(3) + ')' : 'rgba(85,105,130,' + (d.o * 0.75).toFixed(3) + ')';
          ctx.beginPath(); ctx.moveTo(d.x, d.y); ctx.lineTo(d.x + d.l * 0.12, d.y - d.l); ctx.stroke();
        }
      }
      raf = requestAnimationFrame(frame);
    }
    function play() { if (!running) { running = true; raf = requestAnimationFrame(frame); } }
    function stop() { running = false; cancelAnimationFrame(raf); }
    size();
    window.addEventListener('resize', size);
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else play(); });
    play();
    requestAnimationFrame(function () { cv.classList.add('is-on'); });
  }
})();